<template>
  <v-card flat class="settings-card">
    <v-container>
      <graph-and-grid
        Title="Unique Conversations"
        DisplayingText="conversations"
        :Headers="headers"
        ApiPath="/reporting"
        :SearchLocal="true"
        GetParamType="sms"
        GetParamName="unique_customer"
      >
      </graph-and-grid>
    </v-container>
  </v-card>
</template>

<script>
import GraphAndGrid from "../../reports/shared/GraphAndGrid.vue";

export default {
  name: "SMSConversations",
  components: {
    GraphAndGrid
  },
  directives: {},
  data: function() {
    return {
      headers: [
        {
          text: "Customer",
          value: "customer",
          width: "25%"
        },
        {
          text: "Tracking Number",
          align: "start",
          value: "trackingNumber",
          width: "25%"
        },
        {
          text: "Last Message",
          value: "lastDate",
          width: "25%"
        },
        {
          text: "Total Messages",
          value: "count",
          width: "15%"
        },
        {
          text: "Action",
          value: "action",
          width: "1%"
        }
      ]
    };
  },
  computed: {},
  async created() {},
  methods: {},
  watch: {}
};
</script>

<style scoped lang="stylus"></style>
